
export default {
  props: {
    error: {
      type: Object,
      default: () => {},
    },
  },
  head() {
    return {
      title: this.$t('error.500.heading'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('error.500.description'),
        },
      ],
    };
  },
};
